export const vimeoParser = (url) => {
  const regExp =
    /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/?(showcase\/)*([0-9))([a-z]*\/)*([0-9]{6,11})[?]?.*/;
  const match = url.match(regExp);
  return match && match.length === 7 ? match[6] : false;
};
export const youtubeParser = (url) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};

export const booleanToBit = (value = false) => (value ? '1' : '0');

export const calculateHeight = (conWidth, conHeight, actualWidth) =>
  (conHeight * actualWidth) / conWidth;

export const detectVideoSource = (url) => {
  switch (true) {
    case url.includes('youtube') || url.includes('youtu.be'):
      return 'youtube';
    case url.includes('vimeo'):
      return 'vimeo';
    default:
      return 'unknown';
  }
};

const getActualUrl = (url) => {
  switch (detectVideoSource(url)) {
    case 'youtube':
      return `https://www.youtube.com/watch?v=${youtubeParser(url)}`;
    case 'vimeo':
      return `https://vimeo.com/${vimeoParser(url)}`;
    default:
      return url;
  }
};

export const parseIFrame = (iframeString) => {
  const doc = new DOMParser().parseFromString(iframeString, 'text/html');
  const iframeSrc = doc?.body?.children[0]?.src || '';

  if (iframeSrc) {
    const videoSource = detectVideoSource(iframeSrc);
    return {
      videoSource,
      src: getActualUrl(iframeSrc),
      height: parseInt(doc?.body?.children[0]?.height || '9', 10) || 9,
      width: parseInt(doc?.body?.children[0]?.width || '16', 10) || 16,
      title: doc?.body?.children[0]?.title || '',
    };
  }
  return {
    videoSource: 'unknown',
    src: '',
    height: 9,
    width: 16,
    title: '',
  };
};
